export const SNOW_START = { month: 11, day: 15 } // December 15
export const SNOW_END = { month: 0, day: 20 } // January 20

export const flakesCount = 50
